import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Account.TokenAuth.IRequest;
type Response = Api.Core.Account.TokenAuth.IResponse;
type Headers = Api.Core.Account.TokenAuth.IHeaders;
const apiAccountLoginPath = '/api/Auth';
export default async function accountTokenAuth(request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: apiAccountLoginPath,
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
